import $ from 'jquery';

$(document).ready(function(){
    /*ContactUs -> Subscribe form data persister*/
    $('a.largeSubscribe').on('click', function(){
        $('.largeSubscribe').attr('href',
            $.param.querystring($('.largeSubscribe').attr('href'),
                "email="+$('input[name="Email"]').val()
            )
        );

        $('.largeSubscribe').attr('href',
            $.param.querystring($('.largeSubscribe').attr('href'),
                "firstname="+$('input[name="FirstName"]').val()
            )
        );

        $('.largeSubscribe').attr('href',
            $.param.querystring($('.largeSubscribe').attr('href'),
                "lastname="+$('input[name="LastName"]').val()
            )
        );
    });
});

// jQuery.noConflict();
//
// (function($) {
//     $(document).ready(function(){
// 	/*ContactUs -> Subscribe form data persister*/
// 	$('a.largeSubscribe').on('click', function(){
// 	    $('.largeSubscribe').attr('href',
// 				      $.param.querystring($('.largeSubscribe').attr('href'),
// 							  "email="+$('input[name="Email"]').val()
// 							 )
// 				     );
//
// 	    $('.largeSubscribe').attr('href',
// 				      $.param.querystring($('.largeSubscribe').attr('href'),
// 							  "firstname="+$('input[name="FirstName"]').val()
// 							 )
// 				     );
//
// 	    $('.largeSubscribe').attr('href',
// 				      $.param.querystring($('.largeSubscribe').attr('href'),
// 							  "lastname="+$('input[name="LastName"]').val()
// 							 )
// 				     );
// 	});
//     });
// }(jQuery));